import React, { OlHTMLAttributes } from 'react';
import { BLOCKS } from '@contentful/rich-text-types';

import { ILegalPageSectionFields } from '../../../types/contentful';

import { ScrollReveal } from '../ScrollReveal';
import RichText from '../RichText';
import { UnorderedListNode } from '../RichText/Nodes';

export enum orderListTypeEnum {
  uppercaseLetters = 'Uppercase Letters',
  lowercaseLetters = 'Lowercase Letters',
  uppercaseRomanNumerals = 'Uppercase Roman Numerals',
  lowercaseRomanNumerals = 'Lowercase Roman Numerals',
  numbers = 'Numbers',
  greenCaret = 'Green Caret'
}

export const orderedListTypeMapping: {
  [key in orderListTypeEnum]: OlHTMLAttributes<string>['type'];
} = {
  [orderListTypeEnum.uppercaseLetters]: 'A',
  [orderListTypeEnum.lowercaseLetters]: 'a',
  [orderListTypeEnum.uppercaseRomanNumerals]: 'I',
  [orderListTypeEnum.lowercaseRomanNumerals]: 'i',
  [orderListTypeEnum.numbers]: '1',
  [orderListTypeEnum.greenCaret]: undefined
};

export function LegalPageSection({
  sectionId,
  content,
  orderedListStartsAt,
  orderedListType
}: ILegalPageSectionFields) {
  const orderedListTypeIndex =
    (orderedListType as orderListTypeEnum) ?? orderListTypeEnum.numbers;

  return (
    <div id={sectionId!}>
      <ScrollReveal>
        <div
          className="block-container"
          data-blockid="legal-page-section"
          data-testid="legal-page-section"
        >
          <div className="layout flex-col px-3 tablet:px-12 tablet:-mx-3 desktop:-mx-4 desktop:pt-0">
            <div className="box-column w-full tablet:w-2/3 flex-col px-8 tablet:px-0 desktop:px-4">
              <RichText
                overrideOptions={{
                  [BLOCKS.UL_LIST]: (node, children) =>
                    orderedListType === orderListTypeEnum.greenCaret ? (
                      <UnorderedListNode node={node} bulletColor="green">
                        {children}
                      </UnorderedListNode>
                    ) : (
                      <ul className="text-base leading-5 desktop:text-lg desktop:leading-[26px] my-4 pl-10">
                        {children}
                      </ul>
                    ),
                  [BLOCKS.OL_LIST]: (_node, children) => (
                    <ol
                      className="text-base leading-5 desktop:text-lg desktop:leading-[26px] my-4"
                      start={orderedListStartsAt ?? 1}
                      type={orderedListTypeMapping[orderedListTypeIndex]}
                      data-testid="legal-page-section-ol"
                    >
                      {children}
                    </ol>
                  )
                }}
                data={content}
              />
            </div>
          </div>
        </div>
      </ScrollReveal>
    </div>
  );
}
